/* global AOS */

// **********************************************************
// Fade effects
// **********************************************************

// eslint-disable-next-line no-new
AOS.init({
  disable: 'mobile',
  once: true,
  duration: 600,
  easing: 'ease',
});

document.onreadystatechange = function () {
  if (document.readyState === 'complete') {
    AOS.refresh();
  }
};
